<template>
  <div class="painel-home">
    <PainelHeader />

    <main class="painel-home__content">
      <section class="painel-home__section">
        <h2 class="painel-home__section-title">Salas</h2>

        <article class="painel-card">
          <div class="painel-card__head">
            <span class="painel-card__icon painel-card__icon--blue" aria-hidden="true">
              <IconHomeAdd />
            </span>
            <h3 class="painel-card__title">Salas em Tempo Real</h3>
          </div>
          <div class="painel-card__body">
            <p class="painel-card__description">
              Esse painel <strong>exibe o status atual das salas do aplicativo</strong>
              em tempo real, mostrando informações sobre as salas ativas para um gerenciamento
              imediato e melhor tomada de decisões.
            </p>
            <button type="button" class="painel-card__btn painel-card__btn--blue" @click="goto('/painel/salas')">
              Acessar
              <IconChevronRight aria-hidden="true" />
            </button>
          </div>
        </article>
      </section>

      <section class="painel-home__section">
        <h2 class="painel-home__section-title">Outros Painéis</h2>

        <article class="painel-card">
          <div class="painel-card__head">
            <span class="painel-card__icon painel-card__icon--teal" aria-hidden="true">
              <IconLogs />
            </span>
            <h3 class="painel-card__title">Log de Movimentações dos Sistemas</h3>
          </div>
          <div class="painel-card__body">
            <p class="painel-card__description">
              Esse painel registra todas as movimentações nos sistemas, incluindo criação,
              atualização e fechamento de salas, ideal para
              <strong>rastrear ações e monitorar o histórico de atividades</strong>.
            </p>
            <button type="button" class="painel-card__btn painel-card__btn--teal" @click="goto('/painel/logs-movimentacoes')">
              Acessar
              <IconChevronRight aria-hidden="true" />
            </button>
          </div>
        </article>

        <article class="painel-card">
          <div class="painel-card__head">
            <span class="painel-card__icon painel-card__icon--teal" aria-hidden="true">
              <IconGraph />
            </span>
            <h3 class="painel-card__title">Gráfico das Salas Criadas</h3>
          </div>
          <div class="painel-card__body">
            <p class="painel-card__description">
              Visualize análises gráficas relacionadas ao uso das salas virtuais.
              <strong>Acompanhe métricas importantes como latência e o nível de conexão.</strong>
            </p>
            <button type="button" class="painel-card__btn painel-card__btn--teal" @click="goto('/painel/grafico')">
              Acessar
              <IconChevronRight aria-hidden="true" />
            </button>
          </div>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
import PainelHeader from '../components/PainelHeader.vue';
import IconHomeAdd from '@/assets/icons/IconHomeAdd.vue';
import IconLogs from '@/assets/icons/IconLogs.vue';
import IconGraph from '@/assets/icons/IconGraph.vue';
import IconChevronRight from '@/assets/icons/IconChevronRight.vue';

export default {
  name: 'PainelHome',

  components: {
    PainelHeader,
    IconHomeAdd,
    IconLogs,
    IconGraph,
    IconChevronRight
  },

  methods: {
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped src="./PainelHome.css"></style>
